/**
 * Normalize image/audio src in Tiptap JSON to canonical ``/media/...`` storage paths.
 */

import { isTiptapDocument, type TiptapJSON } from '@ai-content-hub/content-kit';
import { normalizeStorageMediaUrl, shouldResolveMediaUrlForViewer } from '@ai-content-hub/content-core';

function normalizeNodeMediaSrc(node: TiptapJSON): boolean {
    let changed = false;

    if (node.type === 'image' || node.type === 'audio') {
        const rawSrc = (node.attrs as { src?: string } | undefined)?.src;
        if (typeof rawSrc === 'string' && shouldResolveMediaUrlForViewer(rawSrc)) {
            const normalized = normalizeStorageMediaUrl(rawSrc);
            if (normalized !== rawSrc) {
                node.attrs = { ...(node.attrs ?? {}), src: normalized };
                changed = true;
            }
        }
    }

    for (const child of node.content ?? []) {
        if (normalizeNodeMediaSrc(child)) {
            changed = true;
        }
    }

    return changed;
}

/**
 * Returns a copy with protected media URLs normalized to ``/media/{key}``, or null if unchanged.
 */
export function normalizeRichTextMediaPaths(content: unknown): TiptapJSON | null {
    if (!isTiptapDocument(content)) {
        return null;
    }
    const doc = structuredClone(content) as TiptapJSON;
    if (!normalizeNodeMediaSrc(doc)) {
        return null;
    }
    return doc;
}
